import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Trees } from 'components/trees'
import { Autocomplete, TextField, FormControl } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import data from './data.json'
import { stationsFr } from '../locales-fr'
import { stationsDe } from '../locales-de'

import 'semantic-ui-css/semantic.min.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'

const ExplainBox = styled.p`
  font-family: var(--font-plex);
`

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const locale = tenant?.lang || 'fr'
  const defaultLoc = {
    tdg: 'GVE',
    '24heures': 'YVD',
    tagesanzeiger: 'SMA',
  }

  const stations = locale === 'fr' ? stationsFr : stationsDe
  const [station, setStation] = useState(
    defaultLoc[
      tenant ? (tenant.key as 'tdg' | '24heures' | 'tagesanzeiger') : 'tdg'
    ]
  )
  const [options, setOptions] = useState([])
  useEffect(() => {
    if (stations) {
      const newOptions = Object.keys(data).map((key) => ({
        key: key,
        label: stations[key],
        value: key,
        id: key,
      }))
      setOptions(newOptions)
    }
  }, [stations])

  const theme = createTheme({
    typography: {
      fontSize: 22,
      fontFamily: 'IBM Plex Sans',
    },
    palette: {
      mode: colorMode === 'dark' ? 'dark' : 'light',
    },
  })
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <TextWidth style={{ paddingBottom: '1em' }}>
        <ThemeProvider theme={theme}>
          {stations && (
            <Autocomplete
              disablePortal
              id='autocomplete'
              options={options}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={locale === 'fr' ? 'Station' : 'Ort'}
                />
              )}
              noOptionsText={
                locale === 'fr'
                  ? 'Aucune station disponible'
                  : 'Keine Messstation verfügbar'
              }
              onChange={(event, data) => {
                setStation(data.value)
              }}
              value={stations[station]}
            />
          )}
        </ThemeProvider>
      </TextWidth>
      <TextWidth>
        <Trees
          dataSet={data[station]}
          locale={locale}
          colorMode={colorMode ? colorMode : 'light'}
        />
        <small
          style={{
            position: 'relative',
            color: '#202346aa',
            fontFamily: 'TamediaChart',
            lineHeight: '1.4em',
            display: 'block',
            marginTop: '3em',
            background: '#F2F0EC',
            borderRadius: '5px',
            padding: '1em',
          }}
        >
          <img
            style={{
              width: '30px',
              position: 'absolute',
              top: '-14px',
              left: '-14px',
              transform: 'rotate(-16deg)',
            }}
            alt='Un chapeau de père Noël'
            src={require('../../images/hat.gif')}
          />
          {locale === 'fr' ? (
            <ExplainBox>
              <b>Où se cache-t-il?</b> Derrière un des sapins de notre
              illustration se cache un petit Père Noël. Un indice: sa cachette
              bouge un peu… cliquez sur les sapins pour le réveiller.
            </ExplainBox>
          ) : (
            <ExplainBox>
              <b>Finden Sie ihn?</b> Hinter einer der Tannen versteckt sich ein
              kleiner Weihnachtsmann. Klicken Sie auf die Bäume in der
              Illustration, um ihn zu entdecken.
            </ExplainBox>
          )}
        </small>
      </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled.div`
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
  padding: 3em 0;
`

export default MainComponent
